const fieldsByRuleType = {
    crew: ["crewSids"],
    crewHistory: ["crewSids", "fromDate", "toDate"],
    worker: ["workerSids"],
    inactiveWorker: ["workerSids"],
    housingSite: ["housingSiteSids"],
    growerMembershipActive: ["growerMembershipActive"],
    latestOnboarding: ["fromDate", "toDate"],
};

export function serializeEmployeeSelection(includeRules, excludeRules) {
    function serializeRule(rule) {
        const fields = fieldsByRuleType[rule.type];
        if (!fields) {
            throw new Error(
                `Unsupported employee selection rule: ${rule.type}`,
            );
        }
        const result = { type: rule.type };
        for (const field of fields) {
            const value = rule[field];
            if (Array.isArray(value)) {
                result[field] = value.map((item) =>
                    typeof item === "string" ? item : item.sid,
                );
            } else if (value !== undefined) {
                result[field] = value;
            }
        }
        return result;
    }
    return {
        include: includeRules.map(serializeRule),
        exclude: excludeRules.map(serializeRule),
    };
}
